import { render, staticRenderFns } from "./WorkflowLinkRulesDialog.vue?vue&type=template&id=5b26925a"
import script from "./WorkflowLinkRulesDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowLinkRulesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports